// reducers.js
import {
    FETCH_COLLECTION_MODAL_DATA_LIST,
    SET_COLLECTION_MODAL_DATA_LIST,
} from '../actions';
import {SET_LATEST_VERSION} from "../actions";
// import {SET_LATEST_VERSION} from "./actionTypes";

const initialState = {
    collectionModalData: null,
    isLoading: false,
    error: null,
};

const collectionModalDataReducer = (state = initialState, action) => {


    switch (action.type) {

        // case SET_LOADING:
        //     return {
        //         ...state,
        //         isLoading: action.payload,
        //     };
        //
        // case SET_ERROR:
        //     return {
        //         ...state,
        //         error: action.payload,
        //     };

        case FETCH_COLLECTION_MODAL_DATA_LIST:
            return {
                ...state,
            };

        case SET_COLLECTION_MODAL_DATA_LIST:
            return {
                ...state,
                collectionModalData: action.payload,
                isLoading: false,
            };

        default:
            return state;
    }
};

export default collectionModalDataReducer;
